<template>
  <div class="flex flex-col p-6 ml-4 lg:ml-64">
    <h2 class="text-xl text-gray-900 font-semibold mb-4">
      Gerenciamento de Usuários
    </h2>
    <div class="mb-6">
      <h3 class="text-lg font-semibold">Empresas</h3>
      <ul class="border rounded p-4 bg-white">
        <li
          v-for="enterprise in filteredEnterprises"
          :key="enterprise._id"
          class="mb-2"
        >
          <button
            @click="openModal(enterprise._id, enterprise.NomeEmpresa)"
            class="w-full text-left bg-blue-500 text-white px-4 py-3 rounded hover:bg-blue-600 focus:outline-none flex flex-col items-start"
          >
            <p class="font-semibold">{{ enterprise.NomeEmpresa }}</p>
          </button>
        </li>
      </ul>
    </div>

    <!-- Modal de Usuários -->
    <div
      v-if="showModal"
      class="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center ml-70"
    >
      <div
        class="bg-white p-6 rounded shadow-lg w-[100%] h-[100%] relative overflow-auto"
      >
        <h3 class="text-lg font-semibold mb-4">
          Usuários da Empresa {{ selectedEnterprise }}
        </h3>

        <ul v-if="employees.length">
          <li
            v-for="(employee, index) in employees"
            :key="employee._id"
            class="mb-4 border-b pb-2"
          >
            <p class="font-medium">{{ employee.NomeFuncionario }}</p>
            <p class="text-sm text-gray-500">{{ employee.email }}</p>
            <div
              class="bg-gray-100 border border-gray-300 rounded px-4 py-2 my-2"
            >
              <div class="mt-2 flex flex-col sm:flex-row sm:items-center gap-2">
                <button
                  @click="generateToken(employee)"
                  class="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                >
                  Gerar Token
                </button>

                <div v-if="employee.token" class="my-2">
                  <div
                    class="text-sm text-gray-800 bg-gray-100 border border-gray-300 rounded px-4 py-2 cursor-pointer hover:bg-gray-200 transition"
                    title="Clique para copiar"
                  >
                    <strong>Email:</strong> {{ employee.Email }}<br />
                    <strong>Token:</strong> {{ employee.token }}
                  </div>
                </div>
              </div>

              <button
                @click="registerUser(employee)"
                :disabled="!employee.token"
                class="mt-2 bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600 disabled:opacity-50"
              >
                Registrar Usuário
              </button>
              <button
                @click="openQuestionModal(employee._id)"
                class="mt-2 bg-purple-500 text-white px-3 py-1 rounded hover:bg-purple-600"
              >
                Ver Respostas
              </button>
            </div>
          </li>
        </ul>

        <p v-else class="text-gray-500">
          Nenhum usuário encontrado para esta empresa.
        </p>
        <div class="mt-4 text-right">
          <button
            @click="closeModal"
            class="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Respostas em Tela Cheia -->
    <div
      v-if="showQuestionModal"
      class="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50"
    >
      <div
        class="bg-white p-6 rounded-none shadow-lg w-full h-full max-w-full max-h-full overflow-auto relative flex flex-col"
      >
        <h3 class="text-xl font-semibold mb-4">Respostas do Funcionário</h3>

        <!-- Componente UserResponsesQuesiton -->
        <UserResponsesQuesiton :EmployeeID="selectedEmployeeId" />

        <div class="mt-4 text-right">
          <button
            @click="showQuestionModal = false"
            class="px-4 py-2 bg-amber-700 rounded hover:bg-gray-400"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>

    <h2 class="text-xl text-gray-900 font-semibold mb-4">
      Gerenciamento de Administradores
    </h2>
    <div class="mb-6">
      <AdminRegisterForm />
    </div>
  </div>
</template>

<script>
import AdminRegisterForm from '@/components/admin/RegisterForm.vue'
import UserResponsesQuesiton from '@/components/ui/UserResponsesQuesiton.vue'
import { register } from '@/services/auth/api.auth'
import { getEmployeesByEnterpriseId } from '@/services/company/api.employees'
import { getEnterprises } from '@/services/company/api.enterprise'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'UserManagement',
  data() {
    return {
      enterprises: [],
      employees: [],
      searchQuery: '',
      showModal: false,
      selectedEnterprise: null,
      showQuestionModal: false,
      selectedEmployeeId: null,
    }
  },
  components: {
    UserResponsesQuesiton,
    AdminRegisterForm,
  },
  computed: {
    filteredEnterprises() {
      const query = this.searchQuery.toLowerCase()
      return this.enterprises.filter(
        (enterprise) =>
          enterprise.Nome?.toLowerCase().includes(query) ||
          '' ||
          enterprise._id?.toString().includes(query) ||
          ''
      )
    },
  },
  methods: {
    openQuestionModal(employeeId) {
      this.selectedEmployeeId = employeeId
      this.showQuestionModal = true
    },

    generateToken(employee) {
      employee.token = uuidv4()
    },

    async fetchEnterprises() {
      try {
        this.enterprises = await getEnterprises()
      } catch (error) {
        console.error('Erro ao buscar empresas:', error)
      }
      this.NomeEmpresa = this.enterprises.map(
        (enterprise) => enterprise.NomeEmpresa
      )
    },
    async openModal(enterpriseId, enterpriseName) {
      await this.fetchEmployersByEnterpriseId(enterpriseId)
      this.selectedEnterprise = enterpriseName
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.employees = []
    },
    async fetchEmployersByEnterpriseId(enterpriseId) {
      try {
        const response = await getEmployeesByEnterpriseId(enterpriseId)
        this.employees = response
      } catch (error) {
        console.error('Erro ao buscar funcionários:', error)
      }
    },
    async registerUser(employee) {
      try {
        const token = uuidv4()
        const role = 'employee'
        await register(
          employee.Email,
          employee.NomeFuncionario,
          employee.token,
          employee.EmpresaID,
          this.selectedEnterprise,
          role
        )

        alert(`Usuário ${employee.NomeFuncionario} registrado com sucesso!`)
      } catch (error) {
        console.error('Erro ao registrar usuário:', error)
        alert(`Erro ao registrar ${employee.NomeFuncionario}`)
      }
    },
  },
  mounted() {
    this.fetchEnterprises()
  },
}
</script>
